import { useState } from 'react';

import { IPublicClientApplication } from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';

import { Stack, Typography } from '@data-products-and-ai/react-components';

import '@/pages/Login/components/AzureLoginButton/AzureLoginButton.scss';

const handleLogin = (msalInstance: IPublicClientApplication) => async () => {
  const isIframe = window.self !== window.top;

  if (isIframe) {
    await msalInstance.loginPopup();
  } else {
    await msalInstance.loginRedirect();
  }
};

export const AzureLoginButton = () => {
  const [errorMessage] = useState(null);
  const { instance } = useMsal();

  const handleClick = () => {
    handleLogin(instance)();
  };

  return (
    <Stack horizontalAlign="center">
      <button className="login-button" onClick={handleClick}>
        <Stack direction="row" horizontalAlign="center">
          <img
            src="/images/azure_white.png"
            height={20}
            style={{ marginRight: 10 }}
            alt="Microsoft azure logo"
          />
          <Typography tag="textdefault">Login with Azure AD</Typography>
        </Stack>
      </button>

      {errorMessage && (
        <div
          className="error-message"
          style={{ color: '$color-red', marginTop: '$spacer-4' }}
        >
          {errorMessage}
        </div>
      )}
    </Stack>
  );
};
